export { useShowcaseShellHeight as useAutoShowcaseShellHeight } from "@/components/services/shared/useShowcaseShellHeight";
